const productionCapacityConstants = {
	// List actions (aligned with subscription pattern)
	PRODUCTION_CAPACITY_LIST_REQUEST: "PRODUCTION_CAPACITY_LIST_REQUEST",
	GET_PRODUCTION_CAPACITY_JOBS: "GET_PRODUCTION_CAPACITY_JOBS", // SUCCESS
	PRODUCTION_CAPACITY_LIST_FAILURE: "PRODUCTION_CAPACITY_LIST_FAILURE",

	// Stats actions (aligned with subscription pattern)
	PRODUCTION_CAPACITY_STATS_REQUEST: "PRODUCTION_CAPACITY_STATS_REQUEST",
	GET_PRODUCTION_CAPACITY_STATS: "GET_PRODUCTION_CAPACITY_STATS", // SUCCESS
	PRODUCTION_CAPACITY_STATS_FAILURE: "PRODUCTION_CAPACITY_STATS_FAILURE",

	// Metrics Chart actions (12-month overview)
	METRICS_CHART_REQUEST: "METRICS_CHART_REQUEST",
	GET_METRICS_CHART: "GET_METRICS_CHART", // SUCCESS
	METRICS_CHART_FAILURE: "METRICS_CHART_FAILURE",

	// Update actions (aligned with subscription pattern)
	PRODUCTION_CAPACITY_UPDATE_REQUEST: "PRODUCTION_CAPACITY_UPDATE_REQUEST",
	PRODUCTION_CAPACITY_UPDATE_SUCCESS: "PRODUCTION_CAPACITY_UPDATE_SUCCESS",
	PRODUCTION_CAPACITY_UPDATE_FAILURE: "PRODUCTION_CAPACITY_UPDATE_FAILURE",

	// Filter and query (aligned with subscription pattern)
	SET_PRODUCTION_CAPACITY_FILTERS: "SET_PRODUCTION_CAPACITY_FILTERS",
	CLEAR_PRODUCTION_CAPACITY_FILTERS: "CLEAR_PRODUCTION_CAPACITY_FILTERS",
	SET_PRODUCTION_CAPACITY_QUERY_PARAMETER:
		"SET_PRODUCTION_CAPACITY_QUERY_PARAMETER",
	CLEAR_PRODUCTION_CAPACITY_QUERY_PARAMETER:
		"CLEAR_PRODUCTION_CAPACITY_QUERY_PARAMETER",

	// Current job (aligned with subscription pattern)
	SET_CURRENT_PRODUCTION_CAPACITY_JOB: "SET_CURRENT_PRODUCTION_CAPACITY_JOB",
	CLEAR_CURRENT_PRODUCTION_CAPACITY_JOB:
		"CLEAR_CURRENT_PRODUCTION_CAPACITY_JOB",

	// Request states (aligned with subscription pattern)
	PC_REQUEST: "PC_REQUEST",
	PC_REQUEST_DONE: "PC_REQUEST_DONE",
	PRODUCTION_CAPACITY_CLEAR_REQUEST_STATE:
		"PRODUCTION_CAPACITY_CLEAR_REQUEST_STATE",

	// Action success/failure (aligned with subscription pattern)
	PC_ACTION_SUCCESS: "PC_ACTION_SUCCESS",
	PC_ACTION_FAILURE: "PC_ACTION_FAILURE",

	// Clear all
	CLEAR_PRODUCTION_CAPACITY: "CLEAR_PRODUCTION_CAPACITY",
};

export default productionCapacityConstants;
